var styles = {"box":"Thumb_box_fkolr_1","button":"Thumb_button_fkolr_30","active":"Thumb_active_fkolr_41","image":"Thumb_image_fkolr_44","text":"Thumb_text_fkolr_50","arrow":"Thumb_arrow_fkolr_56"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
